"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeReader = void 0;
const IonBinaryReader_1 = require("./IonBinaryReader");
const IonConstants_1 = require("./IonConstants");
const IonSpan_1 = require("./IonSpan");
const IonTextReader_1 = require("./IonTextReader");
const IonUnicode_1 = require("./IonUnicode");
/**
 * Indicates whether the provided buffer contains binary Ion data.
 *
 * @param buffer    The buffer of data to inspect.
 * @returns         True if the provided buffer begins with a binary Ion version marker, false otherwise.
 */
function isBinary(buffer) {
    if (buffer.length < 4) {
        return false;
    }
    for (let i = 0; i < 4; i++) {
        if (buffer[i] !== IonConstants_1.IVM.binary[i]) {
            return false;
        }
    }
    return true;
}
/**
 * Create an {Reader} over Ion data in a {ReaderBuffer}.
 *
 * @param buf       The Ion data to be used by the reader. Typically a string, UTF-8 encoded buffer (text), or raw
 *                  binary buffer.
 */
function makeReader(buf) {
    if (typeof buf === "string") {
        return new IonTextReader_1.TextReader(new IonSpan_1.StringSpan(buf));
    }
    const bufArray = new Uint8Array(buf);
    if (isBinary(bufArray)) {
        return new IonBinaryReader_1.BinaryReader(new IonSpan_1.BinarySpan(bufArray));
    }
    else {
        return new IonTextReader_1.TextReader(new IonSpan_1.StringSpan((0, IonUnicode_1.decodeUtf8)(bufArray)));
    }
}
exports.makeReader = makeReader;
